module.exports = __webpack_public_path__ + "img/daftar_pesanan_customer.256334d3.svg";